import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import * as action from 'app/features/orders/redux/order/refundSlice'
import React, {useEffect, useState} from 'react'
import locationService from 'app/services/LocationService/LocationService'

interface Props {}

export const RestockLocation: React.FC<Props> = () => {
  const dispatch = useDispatch()
  const isRestock = useSelector<RootState, boolean>(action.selectIsRestock)
  const [locations, setLocations] = useState<any[]>([])
  const defaultLocationId = useSelector<RootState, string>(action.selectRestockLocationId)

  useEffect(() => {
    const getLocations = async () => {
      const data = await locationService.getLocations()
      setLocations(data)
    }
    getLocations()
  }, [])

  const handleChange = () => {
    dispatch(action.setIsRestock(!isRestock))
  }

  const handleLocationChange = (e: any) => {
    const {value} = e.target
    dispatch(action.setRestockLocationId(value))
  }

  if (locations.length === 0) {
    return null
  }

  return (
    <div className='d-flex w-100'>
      <div className='d-flex align-items-center me-2 gap-3 w-100'>
        <div className='form-check me-6'>
          <input
            type='checkbox'
            className='form-check-input'
            id='selectAll'
            checked={isRestock}
            onChange={handleChange}
          />
          <label htmlFor='selectAll' className='form-check-label cursor-pointer'>
            Restock products to this location
          </label>
        </div>
      </div>

      {/* <div className=' form-check form-check-custom form-check-solid form-check-sm py-2 justify-content-between w-100'>
        <label className='form-check-label fw-bolder fs-6'>
          <input
            className='form-check-input me-3'
            type='checkbox'
            id='chkActive'
            checked={isRestock}
            onChange={handleChange}
          />
          Restock products to this location
        </label>{' '}
      </div>{' '} */}
      <select
        className='form-select'
        name='deliveryType'
        onChange={handleLocationChange}
        defaultValue={defaultLocationId}
        disabled={!isRestock}
      >
        {locations.map((delivery, index) => (
          <option key={index} value={delivery.id}>
            {delivery.name}
          </option>
        ))}
      </select>
    </div>
  )
}

export default RestockLocation
